import { ValueSource } from 'app/views/dashboard/widgets/widget-parameters/value-source.enum';
import { ValueType } from 'app/views/dashboard/widgets/widget-parameters/value-type.enum';
import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class WidgetParameter implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Widget Parameter';
  public readonly apiRoute: string = CONFIG.apiRoutes.widgetParameter;

  public widgetParameterId: string;
  public widgetId: string;
  public guidValue: string;
  public intValue: number;
  public stringValue: string;
  public dateTimeValue: Date;
  public valueType: ValueType;
  public valueSource: ValueSource;
  public displayName: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.widgetParameterId = data.widgetParameterId;
    this.widgetId = data.widgetId;
    this.guidValue = data.guidValue;
    this.intValue = data.intValue;
    this.stringValue = data.stringValue;
    this.valueType = data.valueType;
    this.valueSource = data.valueSource;
    this.dateTimeValue = data.dateTimeValue;
  }
}
